export const GET_ALL_CATEGORY_REQUEST = "CATEGORY.GET_ALL_CATEGORY_REQUEST";
export const GET_ALL_CATEGORY_SUCCESS = "CATEGORY.GET_ALL_CATEGORY_SUCCESS";
export const GET_ALL_CATEGORY_FAILURE = "CATEGORY.GET_ALL_CATEGORY_FAILURE";

export const CLEAR_SEARCHTERM = "CATEGORY.CLEAR_SEARCHTERM";

export const GET_SINGLE_CATEGORY_REQUEST =
  "CATEGORY.GET_SINGLE_CATEGORY_REQUEST";
export const GET_SINGLE_CATEGORY_SUCCESS =
  "CATEGORY.GET_SINGLE_CATEGORY_SUCCESS";
export const GET_SINGLE_CATEGORY_FAILURE =
  "CATEGORY.GET_SINGLE_CATEGORY_FAILURE";

export const ADD_CATEGORY_REQUEST = "CATEGORY.ADD_CATEGORY_REQUEST";
export const ADD_CATEGORY_SUCCESS = "CATEGORY.ADD_CATEGORY_SUCCESS";
export const ADD_CATEGORY_FAILURE = "CATEGORY.ADD_CATEGORY_FAILURE";

export const UPDATE_CATEGORY_REQUEST = "CATEGORY.UPDATE_CATEGORY_REQUEST";
export const UPDATE_CATEGORY_SUCCESS = "CATEGORY.UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_FAILURE = "CATEGORY.UPDATE_CATEGORY_FAILURE";

export const DELETE_CATEGORY_REQUEST = "CATEGORY.DELETE_CATEGORY_REQUEST";
export const DELETE_CATEGORY_SUCCESS = "CATEGORY.DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_FAILURE = "CATEGORY.DELETE_CATEGORY_FAILURE";
